// Vue Router 4 (Vue 3)
import { createRouter, createWebHistory } from 'vue-router'

import Portal from '../views/Portal.vue'
import Terms from '../views/Terms.vue'
import Home from '../views/Home.vue'
import Privacy from '../views/Privacy.vue'
import CookiesPolicy from '../views/CookiesPolicy.vue'
import Impressum from '../views/Impressum.vue'
import TermsOfUse from '../views/TermsOfUse.vue'
import Unsubscription from '../views/Unsubscription.vue'
import Faq from '../views/Faq.vue'
import Contact from '../views/Contact.vue'
import NotFound from '../views/NotFound.vue'
import ProductDetails from '../views/ProductDetails.vue'
import ProductCategory from '../views/ProductCategory.vue'
import SearchResult from '../views/SearchResult.vue'
import DoLogin from '../components/DoLogin.vue'
import ProductDetailsVideo from '../views/ProductDetailsVideo.vue'

import { i18n } from '../plugins/i18n.js'
import { helpers } from '../helper/portal_config'

const routes = [
  // catch-all — '*' is not valid in vue-router 4
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },

  {
    path: '/',
    component: Portal,
    children: [
      { path: '', name: 'Home', component: Home },

      // note: child paths that start with "/" are absolute; unchanged for minimal churn
      { path: '/dologin/:accesscode', component: DoLogin },
      { path: '/product-type/:name?/:id?', name: 'ProductType', component: Home },
      { path: '/terms/:termsversion?/', name: 'Terms', component: Terms },
      { path: '/privacy', name: 'Privacy', component: Privacy },
      { path: '/cookies-policy', name: 'CookiesPolicy', component: CookiesPolicy },
      { path: '/impressum', name: 'Impressum', component: Impressum },
      { path: '/terms-of-use', name: 'TermsOfUse', component: TermsOfUse },
      { path: '/unsubscription', name: 'unsubscription', component: Unsubscription },
      { path: '/faq', name: 'Faq', component: Faq },
      { path: '/contact', name: 'Contact', component: Contact },
      {
        path: '/details/:type/:productId',
        name: 'ProductDetails',
        component: ProductDetails,
        meta: { requiresAccessCode: true },
      },
      {
        path: '/categories/:type/:title/:id',
        name: 'ProductCategory',
        component: ProductCategory,
      },
      { path: '/search/:word?/', name: 'SearchResult', component: SearchResult },

      // testing
      { path: '/detailsVideo/', name: 'ProductDetailsVideo', component: ProductDetailsVideo },
    ],
  },
]

const router = createRouter({
  // Vue CLI uses process.env.BASE_URL
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return new Promise((resolve) => {
      setTimeout(() => resolve({ left: 0, top: 0 }), 400)
    })
  },
})

router.beforeEach((to, from, next) => {
  const { host } = window.location
  const parts = host.split('.')
  const lang = parts[0]?.slice(0, 2)

  if (lang && lang.length === 2) {
    let locale = lang.toLowerCase()
    const map = helpers.countryDefaultLanguage || {}
    if (Object.prototype.hasOwnProperty.call(map, lang.toUpperCase())) {
      locale = map[lang.toUpperCase()].toLowerCase()
    }

    // vue-i18n v9
    // legacy: true -> string; legacy: false -> Ref
    try {
      i18n.global.locale = locale
    } catch {
      i18n.global.locale.value = locale
    }
  }

  if (to.matched.some((record) => record.meta?.requiresAccessCode)) {
    if (!localStorage.getItem('accessCode')) {
      if (from.name === 'ProductType') next({ path: from.path || '/' })
      else next({ path: '/' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
